{
  "title": "Två på två",
  "newQuickArticleTitle": "Skapa ny två på två"
}
